module.exports = __webpack_public_path__ + "static/img/年度最佳冰箱.f444241c.png";